export default __webpack_public_path__ + "static/media/ban-3.9f6e72b6.jpg";